import React from "react";

const KpiCard = ({ value, label, icon, color, trend, trendType, onClick, clickable = false }) => (
   <div
      className={`kpi-card ${color} ${clickable ? "clickable" : ""}`}
      onClick={onClick}
      style={{ cursor: clickable ? "pointer" : "default" }}
   >
      <div className="kpi-header">
         <div>
            <div className="kpi-value">{value}</div>
            <p className="kpi-label">{label}</p>
            {trend && (
               <span className={`kpi-trend ${trendType || ""}`}>
                  <i className={`bi bi-arrow-${trendType === "down" ? "down" : "up"}`}></i>
                  {trend}
               </span>
            )}
         </div>
         <div className={`kpi-icon ${color}`}>
            <i className={icon}></i>
         </div>
      </div>
   </div>
);

export default KpiCard;
